export const ADVANCED_TRADING_DASHBOARD_PATHS = {
  ROOT: "/pro",
  LEGACY_LAYOUT_LABS: "/pro/layout-labs",
};
